import Vue from 'vue'
import qs from 'qs'

import { cleanObject, generateExcelLink } from '@/util/helpers'

import {
  list,
  fetchDetails,
  createReport,
  retryTransfer,
} from '@/services/transfer/transferService'

const state = {
  transfers: [],
  transfer: null,
  isBeingTransfer: false,
  isGeneratingReport: false,
  wasTransferred: false,
}

const getters = {
  transfers: (state) => state.transfers,
  transfer: (state) => state.transfer,
  isBeingTransfer: (state) => state.isBeingTransfer,
  isGeneratingReport: (state) => state.isGeneratingReport,
  wasTransferred: (state) => state.wasTransferred,
}

const actions = {
  async fetchTransfers({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = {
      ...defaultParams,
      ...rootState.filters.filters
    }

    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const { data } = await list(parsedParams)
      const { result, total } = await data
      commit('setTransfers', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchTransfer({ commit, dispatch }, id) {
    commit('setIsLoading', true)

    try {
      const { data } = await fetchDetails(id)
      commit('setTransfer', data)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async fetchTransferReport({ commit, dispatch, rootState }) {
    commit('setIsGeneratingReport', true)

    const params = rootState.filters.filters
    const parsedParams = qs.stringify(cleanObject(params), { arrayFormat: 'repeat' })

    try {
      const response = await createReport(parsedParams)
      generateExcelLink(response, Vue.i18n.translate('transfer.label.transferReport'))
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsGeneratingReport', false)
    }
  },

  async executeTransfers({ commit, dispatch }, transfers) {
    commit('setWasTransferred', false)
    commit('setIsBeingTransfer', true)

    try {
      await retryTransfer({ transfer_id_list: transfers })

      dispatch('fetchTransfers')
      dispatch('showSuccessMessage',  Vue.i18n.translate('transfer.hint.successMessage'))

      commit('closeAllModals')
      commit('setWasTransferred', true)
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsBeingTransfer', false)
    }
  },

  // "duplicated" to avoid add conditionals
  async retryTransfers({ commit, dispatch }, transfers) {
    commit('setWasTransferred', false)
    commit('setIsBeingTransfer', true)

    try {
      await retryTransfer({ transfer_id_list: transfers })
      dispatch('showSuccessMessage',  Vue.i18n.translate('transfer.hint.successMessage'))
      commit('setWasTransferred', true)
      commit('closeAllModals')
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsBeingTransfer', false)
    }
  }
}

const mutations = {
  setTransfers: (state, transfers) => {
    state.transfers = transfers
  },

  setTransfer: (state, transfer) => {
    state.transfer = transfer
  },

  setIsBeingTransfer: (state, status) => {
    state.isBeingTransfer = status
  },

  setIsGeneratingReport: (state, status) => {
    state.isGeneratingReport = status
  },

  setWasTransferred: (state, status) => {
    state.wasTransferred = status
  }
}

export default {
  state,
  mutations,
  actions,
  getters,
}
